export class RegistrationProfileBenefit {
  public ProfileBenefitId: number;
  public EventBenefitId: number;
  public BenefitTypeId: number;
  public BenefitType: string;
  public QuantityToApply: number;
  public ValueToApply: number;
  public ProfileId: number;
  public LimitType: number;
  public RegistrationId: number;
  public LimitAmount: number;
  public EventPriceId: number;
  public constructor() {
    this.ProfileBenefitId = 0;
    this.EventBenefitId = 0;
    this.BenefitTypeId = 0;
    this.BenefitType = '';
    this.QuantityToApply = 0;
    this.ValueToApply = 0;
    this.ProfileId = 0;
    this.LimitType = 0;
    this.RegistrationId = 0;
    this.LimitAmount = 0;
    this.EventPriceId = 0;
  }
}
